/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
import React, { useState, useEffect } from 'react';
import Lodash from 'lodash';
import { useJwt } from 'react-jwt';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import Storage from '../../Storage/Storage';

const UploadFile = props => {
  const {
    classes,
    // eslint-disable-next-line no-unused-vars
    disabled,
    rowData,
    listData,
    setAllList,
  } = props;
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [fileUrl, setFileUrl] = useState('');

  const tokenData = Storage.instance;
  const { decodedToken } = useJwt(tokenData.getToken());

  const removeFile = () => {
    setFile(null);
  };
  const handleFileChange = e => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file)
      return alert('Selecciona un archivo primero.');

    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'my-preset');
    formData.append('api_key', '632982337546875');
    formData.append('resource_type', 'raw'); // Permite subir archivos PDF, DOC, etc.
    formData.append(
      'folder',
      `/sectores/files/${decodedToken.num_cedula}`,
    );

    try {
      const response = await axios.post(
        'https://api.cloudinary.com/v1_1/dgu10iegq/raw/upload',
        formData,
      );

      setFileUrl(response.data.secure_url);
      setUploaded(true);
      setLoading(false);
      const delegado = Lodash.find(listData, {
        id: rowData.lugar,
      });

      delegado.urlFile = response.data.secure_url;
      delegado.nameFile = file.name;

      const newList = Lodash.union([delegado], listData);
      const orderedList = Lodash.orderBy(
        newList,
        ['id'],
        ['asc'],
      );
      setAllList(orderedList);
    } catch (error) {
      console.error('Error al subir archivo:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(rowData);
  }, [file]);

  return (
    <>
      <IconButton
        className={classes.btnAttachFileActive}
        aria-label="upload"
        component="label"
        style={{ padding: 6 }}
        disabled={disabled}
      >
        <AttachFileIcon />
        <input
          hidden
          type="file"
          onChange={handleFileChange}
        />
      </IconButton>
      <input
        type="text"
        readOnly
        value={
          // eslint-disable-next-line no-nested-ternary
          file
            ? file.name
            : rowData.nameFile
            ? rowData.nameFile
            : ''
        }
        style={{ border: 'none', pointerEvents: 'none' }}
      />

      {file && fileUrl === '' && !loading && (
        <>
          <IconButton
            type="button"
            className={classes.btnAttachFileActive}
            aria-label="upload"
            style={{ padding: 6 }}
            disabled={disabled}
            onClick={handleUpload}
          >
            <CloudUploadIcon />
          </IconButton>
          <IconButton
            type="button"
            className={classes.btnRemoveFileActive}
            aria-label="upload"
            style={{ padding: 6 }}
            disabled={disabled}
            onClick={removeFile}
          >
            <CloseIcon />
          </IconButton>
        </>
      )}
      {loading && (
        <IconButton
          className={classes.btnAttachFileActive}
          aria-label="upload"
          style={{ padding: 6 }}
          disabled={disabled}
          component="label"
        >
          <CircularProgress
            style={{
              width: '20px',
              height: '20px',
            }}
          />
        </IconButton>
      )}
      {uploaded && (
        <IconButton
          className={classes.btnAttachFileActive}
          aria-label="upload"
          style={{ padding: 6 }}
          disabled={disabled}
          component="label"
        >
          <CheckCircleIcon />
        </IconButton>
      )}
    </>
  );
};

export default UploadFile;
